export default "__VITE_ASSET__DGXM9wwn__"